import { faMicrophone } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const recorderToolkit = ({ isRecording }) => {
  if (!isRecording) return null;

  return (
    <div className="flex items-center justify-center px-4 py-1 mb-1 border border-yellow-300 rounded-lg shadow-sm w-fit place-self-center bg-yellow-50">
      <div className="mr-3 text-yellow-500">
        <FontAwesomeIcon
          icon={faMicrophone}
          className="w-4 h-4"
        />
      </div>
      <p className="text-xs font-medium text-yellow-700">
        Please speak clearly. External factors such as background noise may
        affect the quality of your recording.
      </p>
    </div>
  );
};
